import { GET_SAMPLE_FILE, CLEAR_RESPONSE, RESPONSE_STATUS } from './bulkTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }

        default:
            return state
    }
}
